export default __webpack_public_path__ + "static/1-e03d562e5d19d4e9e9343d989ead2e5f.jpg";